import { render, staticRenderFns } from "./RealTimesGold.vue?vue&type=template&id=3f17c055&scoped=true&"
import script from "./RealTimesGold.vue?vue&type=script&lang=js&"
export * from "./RealTimesGold.vue?vue&type=script&lang=js&"
import style0 from "./RealTimesGold.vue?vue&type=style&index=0&id=3f17c055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17c055",
  null
  
)

export default component.exports